import React from "react";
import {Dropdown, DropdownChangeParams} from "primereact/dropdown";
import useAccessibleCompanies from "../../../hooks/useAccessibleCompanies";
import {useUserState} from "../../../store/user-store";
import useCurrentCompanyContext from "../../../hooks/useCurrentCompanyContext";

export default function CompanyContextSelectFragment() {
    const companies = useAccessibleCompanies()
    if(!companies) return false

    if(companies.length <= 1) {
        return false
    }

    const currentContext = useCurrentCompanyContext()
    const setCurrentContext = useUserState((state) => state.setCompanyContext)

    const selectItems =  companies?.map((company) => {
        return {
            label: company.title,
            value: company.companyReference
        }
    })

    const onChangeHandler = (e: DropdownChangeParams) => {
        const company = companies?.find((company) => company.companyReference === e.value)
        setCurrentContext(company)
    }

    return <>
        <Dropdown placeholder="Select company context"
                  value={currentContext?.companyReference}
                  options={selectItems}
                  filter={true}
                  filterMatchMode="contains"
                  onChange={onChangeHandler}
        />
    </>
}